export const RESULT_STATE = {
  confirmed: 'CONFIRMED',
  failure: 'FAILURE',
  pending: 'PENDING'
}
